import Nav from "./Components/Nav";
import Main from "./Components/Main";

function App() {
  return (
 <div>
<Nav />

<Main />
 </div>
  );
}

export default App;
